import { SEO_ORIGIN } from './company'
import { withLocalePath } from './i18n-utils'
import { workFeedHref } from './community-feed-location'
import type { PublicWork } from '@/server/commons/public-work'

export function workHead(
  data: PublicWork | undefined,
  id: string,
  locale: string,
) {
  if (!data || data.id !== id || !['open', 'closed'].includes(data.status))
    return { meta: [{ name: 'robots', content: 'noindex,follow' }] }
  const title = `${data.title} — Horizon Tech Commons`
  const description = data.brief.replace(/\s+/g, ' ').trim().slice(0, 180)
  const url = SEO_ORIGIN + withLocalePath(`/community/work/${id}`, locale)
  return {
    meta: [
      { title },
      { name: 'description', content: description },
      { name: 'robots', content: 'index,follow' },
      { property: 'og:title', content: title },
      { property: 'og:description', content: description },
      { property: 'og:url', content: url },
      { name: 'twitter:title', content: title },
      { name: 'twitter:description', content: description },
    ],
    links: [{ rel: 'canonical', href: url }, { rel: 'alternate', type: 'application/rss+xml', title: locale === 'bs-BA' ? 'Ažuriranja zadatka' : 'Task updates', href: SEO_ORIGIN + workFeedHref(id) }],
  }
}
